import './App.css';
import paises from './paises.json';
import { verificaNIF} from "./utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {
    Input,
    Button, NativeSelectRoot, NativeSelectField,Field
} from "@chakra-ui/react";
import * as React from 'react'
import { useNavigate } from 'react-router-dom';
import {FormControlLabel, Radio, RadioGroup} from "@mui/material";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import { es } from 'date-fns/locale/es';

function App() {
    let navigate = useNavigate();
    const [formData, setFormData] = React.useState({"Provincia cita": ""});
    const [mandatoryFormData, setmandatoryFormData] = React.useState([]);
    const [showResidencia, setShowResidencia] = React.useState(false);
    const [allMandatoryFilled, setallMandatoryFilled] = React.useState(false);
    const [selectedCountryValue, setSelectedCountryValue] = React.useState('348');
    const [startDate, setStartDate] = React.useState(new Date());
    var current_date = new Date();
    const [endDate, setEndDate] = React.useState(new Date(current_date.getFullYear() + 1, current_date.getMonth(), current_date.getDate()));
    registerLocale('es', es)

    React.useEffect(() => {
        setPaisCanje();
    }, []);

    const decodeJwtPayload = (token) => {
        const parts = token.split(".");
        if (parts.length !== 3) {
            throw new Error("Invalid JWT format");
        }

        const payloadBase64 = parts[1];
        const decodedPayload = atob(payloadBase64);
        return JSON.parse(decodedPayload);
    };

    const setPaisCanje = async () => {
        const defaultData = {"txtIdCitado": "", "txtNombre": "", "txtApellido1": "", "txtApellido2": "", "txtTelefonoCitado": "", "txtMailCitado": "", "txtDetalleCita": ""};
        const defaultMandatoryData = ["txtIdCitado", "txtNombre", "txtApellido1", "txtTelefonoCitado", "txtMailCitado", "txtDetalleCita"];

        const token = searchParams.get("token")
        const payload = decodeJwtPayload(token)

        console.log(payload)

        defaultData["FechaMIN"] = startDate.toLocaleDateString('en-GB')
        defaultData["FechaMAX"] = endDate.toLocaleDateString('en-GB')
        defaultData["token"] = token
        defaultData["tipo_bot"] = "RC_GENCAT"
        defaultData["price"] = payload["price"]
        defaultData["tguser"] = payload["tguser"]
        defaultData["rdbTipoDoc"] = "nie"
        defaultData["txtPaisNac"] = "350"
        setFormData(defaultData);
        setmandatoryFormData(defaultMandatoryData);
    }

    const [showNumResolucion, setShowNumResolucion] = React.useState(false);
    const [showFechaResolucion, setShowFechaResolucion] = React.useState(false);

    const handleSubmit = async () => {
        if (validateForm()) {
            // For now, just log the data. In real scenarios, you'd send this to a server.
            console.log(formData);

            fetch('https://api.notifybotstg.com/api/insert_new_tg_appointment', {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Success:', data);
                    navigate('success');
                })
                .catch((error) => {
                    console.error('Error:', error);
                    navigate('error');
                });
        }
    };

    const validateForm = () => {
        var fulfilled = true;
        console.log(formData)

        mandatoryFormData.forEach(field => {
            console.log(field)
            if ((formData[field] === '') || (Array.isArray(formData[field]) && formData[field].length == 0)) {
                fulfilled = false;
                console.log(formData[field])
                setallMandatoryFilled(true)
            }
        });

        fulfilled = fulfilled && (formData["rdbTipoDoc"] === "passaport" ||
                                  formData["rdbTipoDoc"] === "documentIdentitatEstranger" ||
                                  formData["rdbTipoDoc"] === "targetaSanitaria" || verificaNIF(formData["txtIdCitado"]));

        return fulfilled;
    }

    const handleInputChange = (event) => {
        console.log(event)

        setFormData({
            ...formData,
            [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value.trimStart()
        });
    };

    const searchParams = new URLSearchParams(document.location.search)

    const [tipoDoc, setTipoDoc] = React.useState('nie');

    return (
        <div>
            <div className="form">
                <div className="grid-container">
                    <div key="rdbTipoDoc" className="input-wrapper">
                        <label>Tipo de documento<b style={{color: 'red'}}>{" *"}</b></label>
                        <RadioGroup
                            name="rdbTipoDoc"
                            value={tipoDoc}
                            onChange={(newValue) => {
                                setTipoDoc(newValue.target.value)
                                formData["rdbTipoDoc"] = newValue.target.value
                            }}
                        >
                            <FormControlLabel value="nif" control={<Radio/>} label="DNI"/>
                            <FormControlLabel value="passaport" control={<Radio/>} label="Passaport"/>
                            <FormControlLabel value="nie" control={<Radio/>} label="NIE"/>
                            <FormControlLabel value="documentIdentitatEstranger" control={<Radio/>}
                                              label="Document d'identitat estranger"/>
                            <FormControlLabel value="targetaSanitaria" control={<Radio/>}
                                              label="Targeta sanitària individual"/>
                        </RadioGroup>
                    </div>
                    <div key="txtIdCitado" className="input-wrapper">
                        <label>Número de documento<b style={{color: 'red'}}>{" *"}</b></label>
                        <Field.Root invalid={formData["txtIdCitado"] !== undefined && !(formData["rdbTipoDoc"] === "passaport" ||
                            formData["rdbTipoDoc"] === "documentIdentitatEstranger" ||
                            formData["rdbTipoDoc"] === "targetaSanitaria" || verificaNIF(formData["txtIdCitado"]))}>
                            <Input
                                name="txtIdCitado"
                                type="text"
                                value={formData["txtIdCitado"] || ''}
                                onChange={handleInputChange}
                                placeholder=''
                            />
                            <Field.ErrorText>Introduce un documento valido</Field.ErrorText>
                        </Field.Root>
                    </div>
                    {(formData["rdbTipoDoc"] === "passaport" || formData["rdbTipoDoc"] === "documentIdentitatEstranger") &&
                    <div id="txtPaisNac" className="input-wrapper"
                         style={{display: showResidencia ? "none" : "flex"}}>
                        <label>País de nacionalidad <b style={{color: 'red'}}> *</b></label>
                        <NativeSelectRoot size="sm" width="240px" name="txtPaisNac"
                                          value={selectedCountryValue} onChange={handleInputChange}>
                            <NativeSelectField name="txtPaisNac">
                                <option key="Seleccionar" value="Seleccionar">Seleccionar</option>
                                {paises.map(opt => (
                                    <option name="txtPaisNac" key={opt["value"]} value={opt["value"]}>{opt["text"]}</option>
                                ))}
                            </NativeSelectField>
                        </NativeSelectRoot>
                    </div>
                    }
                    <div key="txtNombre" className="input-wrapper">
                        <label>Nombre<b style={{color: 'red'}}>{" *"}</b></label>
                        <Input
                            name="txtNombre"
                            type="text"
                            value={formData["txtNombre"] || ''}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </div>
                    <div key="txtApellido1" className="input-wrapper">
                        <label>Primer Apellido<b style={{color: 'red'}}>{" *"}</b></label>
                        <Input
                            name="txtApellido1"
                            type="text"
                            value={formData["txtApellido1"] || ''}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </div>
                    <div key="txtApellido2" className="input-wrapper">
                        <label>Segundo Apellido<b style={{color: 'red'}}>{" *"}</b></label>
                        <Input
                            name="txtApellido2"
                            type="text"
                            value={formData["txtApellido2"] || ''}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </div>
                    <div key="txtTelefonoCitado" className="input-wrapper">
                        <label>Teléfono<b style={{color: 'red'}}>{" *"}</b></label>
                        <Field.Root invalid={formData["txtTelefonoCitado"] && (formData["txtTelefonoCitado"].length < 9 && formData["txtTelefonoCitado"].length > 0)}>
                            <Input
                                name="txtTelefonoCitado"
                                type="tel"
                                value={formData["txtTelefonoCitado"] || ''}
                                onChange={handleInputChange}
                                placeholder=''
                                minLength={9}
                                maxLength={9}
                            />
                            <Field.ErrorText>Introduce un teléfono valido</Field.ErrorText>
                        </Field.Root>
                    </div>
                    <div key="txtMailCitado" className="input-wrapper">
                        <label>Correo electrónico<b style={{color: 'red'}}>{" *"}</b></label>
                        <Input
                            name="txtMailCitado"
                            type="email"
                            value={formData["txtMailCitado"] || ''}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </div>
                    <div key="txtDetalleCita" className="input-wrapper">
                        <label>Detalle Cita<b style={{color: 'red'}}>{" *"}</b></label>
                        <Input
                            name="txtDetalleCita"
                            type="text"
                            value={formData["txtDetalleCita"] || ''}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </div>
                    <div id="FechaMIN" className="input-wrapper"
                         style={{display: showResidencia ? "none" : "flex"}}>
                        <label>Buscar fecha a partir del</label>
                        <DatePicker
                            showIcon
                            selected={startDate}
                            onSelect={(date) => setStartDate(date)}
                            onChange={(date) => {
                                var event = {
                                    "target": {
                                        "name": "FechaMIN",
                                        "value": date.toLocaleDateString('en-GB'),
                                        "type": "datepicker"
                                    }
                                };
                                handleInputChange(event)
                            }}
                            onChangeRaw={event => {
                                const date = moment(event.target.value, "DD/MM/YYYY");
                                if (date.isValid()) {
                                    setStartDate(date.toDate());
                                }
                            }}
                            name="FechaMIN"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            locale="es"
                        />
                    </div>
                    <div id="FechaMAX" className="input-wrapper"
                         style={{display: showResidencia ? "none" : "flex"}}>
                        <label>Hasta el día</label>
                        <DatePicker
                            showIcon
                            selected={endDate}
                            onSelect={(date) => setEndDate(date)}
                            onChange={(date) => {
                                var event = {
                                    "target": {
                                        "name": "FechaMAX",
                                        "value": date.toLocaleDateString('en-GB'),
                                        "type": "datepicker"
                                    }
                                };
                                handleInputChange(event)
                            }}
                            onChangeRaw={event => {
                                const date = moment(event.target.value, "DD/MM/YYYY");
                                if (date.isValid()) {
                                    setEndDate(date.toDate());
                                }
                            }}
                            name="FechaMAX"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            minDate={startDate}
                            locale="es"
                        />
                    </div>
                    <Button style={{width: "100%"}} class="sendButton" variant="contained" color="primary"
                            onClick={handleSubmit}
                    >Enviar solicitud</Button>

                </div>
                {allMandatoryFilled && <p>Rellena todos los campos obligatorios *</p>}
                <div></div>
            </div>
        </div>
    );
}

export default App;
